import React, { useEffect } from 'react';
import '../../styles/legal.css';

const Cancellation: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        
        <div className="legal-header">
          <h1 className="legal-title">Cancellation and Return Policy</h1>
          <p className="legal-subtitle">Last updated: May 10, 2026</p>
        </div>

        <div className="legal-content">
          <p>Industrybull is happy to serve customer and fulfil their requirements. If customer receives any product which fulfils the below mentioned criterion, customer is eligible for return / exchange:</p>
          <ul>
            <li>Product is used/altered/Defective product.</li>
            <li>Physical / in-transit damage to the product.</li>
            <li>Branded product received seal opened.</li>
            <li>Empty packet/some items or accessories are missing.</li>
            <li>Significant difference found in Industrybull website as comparison to product.</li>
          </ul>
          
          <h2>Customer is not eligible for return/exchange if</h2>
          <ul>
            <li>Its “No longer needed”.</li>
            <li>Customer tried to handle the industrial product and unable to use it which promotes any tear/damage.</li>
            <li>Made to Product(on demand) will not be returned.</li>
            <li>Office Chair Return/Exchange Policy- Please note that returns or exchanges are not applicable for office chairs. However, in the event that the chair arrives with a broken part or missing accessory, we will promptly dispatch the required replacement part(s) to your specified location at no additional cost.</li>
          </ul>
          
          <h2>Guidelines for Return/Exchange:</h2>
          <ul>
            <li>For Products purchased on Industrybull, in the event the customer has any concern with the Product, the customer shall inform to Industrybull Customer care within 48 Hours of product delivery.</li>
            <li>Customer must share video with Customer care team while opening the package in case of Empty Package/Quantity issue.</li>
            <li>Customer need to share 7-8 images of the Complete product, Product packaging/box (Outer & Inner) & Shipment label while raising the Return or Replacement request.</li>
            <li>In case of Industrial goods return will be accepted only in case of wrong, defective, damaged product.</li>
            <li>In Case of Faulty electronics product, customer need to contact nearest service centre for repair/ replacement.</li>
            <li>All products must be in new and unopened condition with all the original packing, tags, inbox literature, warranty/ guarantee card, freebies and accessories including keys, straps and locks intact.</li>
            <li>Industrybull shall endeavour to process the customer refund within 7 (Seven) working days from the date of request made to the Customer Care team.</li>
            <li>The returns scheme is offered by sellers, allowing exchanges, replacements, or refunds. Return policies may vary by product category, with the product page policy taking precedence over the general one.</li>
          </ul>
          
          <h2>Below Mentioned products are non-returnable:</h2>
          <div className="legal-table-wrap">
            <table>
              <tbody>
                <tr>
                  <td>Category</td>
                  <td>Product Type</td>
                </tr>
                <tr>
                  <td>Automotive</td>
                  <td>Lubricants, greases, oils, waxes, polishes & other liquid.</td>
                </tr>
                <tr>
                  <td>Medical or Lab Supplies</td>
                  <td>No return policy against any issue.</td>
                </tr>
                <tr>
                  <td>Tapes, Adhesives, Sealants, Welding, Paints & Coatings, Lubricants, Coolants & Industrial Oils</td>
                  <td>Adhesives (all liquids), hazardous materials and lubricants.</td>
                </tr>
                <tr>
                  <td>Abrasives</td>
                  <td>Abrasive Powders & Pastes no return.</td>
                </tr>
                <tr>
                  <td>Cleaning Equipment</td>
                  <td>Floor Polishers / Cleaning Sprays</td>
                </tr>
                <tr>
                  <td>Electricals</td>
                  <td>Refunds will not be initiated on electrical / Electronic products / large appliances.</td>
                </tr>
                <tr>
                  <td>Lighting and Luminaries</td>
                  <td>All type of Lights is non-returnable.</td>
                </tr>
                <tr>
                  <td>Measurement & Testing</td>
                  <td>Calibration related issues should be handled by Supplier / Manufacturer directly.</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p>Note: Industrybull is always happy to help customer if customer fails to understand the working of product, Customer can contact. Industrybull customer care team either through email / phone. If customer received defective product after 1st time exchange, Industrybull will connect customer with Supplier/Brand to troubleshoot the issue.</p>
        </div>

      </div>
    </div>
  );
};

export default Cancellation;
